import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../reducers'
import { selectPromos } from '../../../reducers/promos'

export default function PromosSubHeader() {
    const { t } = useTranslation()
    const promos = useAppSelector(selectPromos)
    const activePromos = promos.filter(
        promo => moment(new Date()).isBetween(promo.date_start, promo.date_end)
    )

    return (
        <>
            {t('promos-active-count', { count: activePromos.length })}
        </>
    )
}
